import { history } from 'umi';
import { setOemInfos, baseState } from '@/states/store';
import request from '@/utils/request';
import dayjs from 'dayjs';
const { UMI_ENV } = process.env

export const getOemInfos = async (needUpdate=false) => {
  try {
    const localData = window.localStorage.getItem('oemInfos');
    if (localData&&!needUpdate) {
      const { data, expire } = JSON.parse(localData);
      const now = dayjs();
      const expireTime = dayjs(expire);
      if (now.isBefore(expireTime)) {
        setOemInfos(data);
        return data;
      }
    }
    window.localStorage.removeItem('oemInfos');
    const res: any = await getOemInfosApi();
    const oemInfos = res?.data;
    if (oemInfos) {
      setOemInfos(oemInfos);
      const newExpire = dayjs().endOf('day').valueOf();
      const newLocalData = { data: oemInfos, expire: newExpire };
      window.localStorage.setItem('oemInfos', JSON.stringify(newLocalData));
      return oemInfos;
    }
    return baseState.oemInfos;
  } catch (e) {
    return baseState.oemInfos;
  }
};

const getOemInfosApi = () => {
  const oemNameMap: Record<string, string> = {
    '': 'saas',
    'waimao': '',
  };
  const oemName = oemNameMap[baseState.userInfo.loginSource ?? ''] ?? 'saas';
  return request({
    url: '/waic/core/common/oemInfo',
    data: {
      oemName,
    }
  });
};

export const intercept = async () => {
  try {
    if (UMI_ENV === 'dev'||/wai-c-web/i.test(window.location.hostname) || /wime-ai/i.test(window.location.hostname)) {
      return;
    }
    const oemInfos: any = await getOemInfos();
    if (oemInfos?.hideMenuPaths?.includes(history.location.pathname)) {
      history.push('/');
      return false;
    }
    return true;
  } catch (e) {
    return true;
  }
};
